var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeliz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.988 0C5.364 0 0 5.376 0 12C0 18.624 5.364 24 11.988 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 11.988 0ZM12 21.6C6.69602 21.6 2.40002 17.304 2.40002 12C2.40002 6.69596 6.69602 2.39996 12 2.39996C17.304 2.39996 21.6 6.69596 21.6 12C21.6 17.304 17.304 21.6 12 21.6ZM18 9.00007C18 9.99607 17.196 10.8001 16.2 10.8001C15.204 10.8001 14.4 9.99607 14.4 9.00007C14.4 8.00407 15.204 7.20007 16.2 7.20007C17.196 7.20007 18 8.00407 18 9.00007ZM7.8 10.8001C8.796 10.8001 9.6 9.99607 9.6 9.00007C9.6 8.00407 8.796 7.20007 7.8 7.20007C6.804 7.20007 6 8.00407 6 9.00007C6 9.99607 6.804 10.8001 7.8 10.8001ZM17.8571 15.0899C16.5737 16.9059 14.3969 18 12.0063 18C9.61564 18 7.4389 16.9172 6.14291 15.0899C5.8661 14.6951 6.00451 14.1763 6.44489 13.9281C6.60846 13.8492 6.77203 13.804 6.94819 13.804C7.26274 13.804 7.5773 13.9394 7.75346 14.1988C8.68455 15.5298 10.2699 16.3194 12.0063 16.3194C13.7427 16.3194 15.328 15.5298 16.2591 14.1988C16.5359 13.804 17.1147 13.68 17.5551 13.9281C17.9955 14.1763 18.1339 14.6951 17.8571 15.0899Z",
    fill: "#7CC6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeliz);
export default __webpack_public_path__ + "static/media/Feliz.2410604395a0a13aadb9051d54f4490f.svg";
export { ForwardRef as ReactComponent };